import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { CheckCircle2, Zap, Eye, Clock } from "lucide-react";

export default function AboutPage() {
  return (
    <div className="bg-grain min-h-screen" data-testid="about-page">
      <Header />
      <main>
        <section className="relative pt-16 md:pt-24 pb-20">
          <div className="max-w-4xl mx-auto px-5 sm:px-8 relative">
            <div className="corner-bracket tl" />
            <div className="corner-bracket tr" />
            <div className="pt-6 pb-2">
              <span className="pill">Our Mission</span>
              <h1 className="mt-5 font-display font-black text-white text-5xl md:text-6xl tracking-tighter leading-[1.05]">
                Content shouldn't cost <span className="text-[#3B9EFF]">a kidney.</span>
              </h1>
              <p className="mt-6 text-lg text-[#A0AABF] leading-relaxed">
                ContentSnap exists because we got tired of watching small business owners drown.
                Owners juggling 17 hats — sales, ops, payroll, customer service — and then expected
                to also be a video editor, graphic designer, and copywriter on the side.
              </p>
              <p className="mt-4 text-lg text-[#A0AABF] leading-relaxed">
                Agencies charge $1,500/month. Freelancers ghost. Tools take 40 hours to master.
                None of that is built for the guy fixing roofs or the woman running a salon.
              </p>
              <p className="mt-4 text-lg text-white leading-relaxed">
                So we built something different. Pay. Fill a form. Get content in 72–96 hours. That's it.
              </p>
            </div>
          </div>
        </section>

        <section className="py-16 border-t border-[#3B9EFF]/10">
          <div className="max-w-5xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-10">
            <div>
              <h2 className="font-display font-bold text-white text-3xl md:text-4xl tracking-tighter">
                We don't sell hours. <span className="text-[#3B9EFF]">We sell outcomes.</span>
              </h2>
              <p className="mt-4 text-[#A0AABF] leading-relaxed">
                Most agencies sell you "deliverables" and "revisions" and "strategy sessions."
                Our customers don't care about any of that. They care about one thing: did the content
                show up, and did it look good. So that's what we deliver.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: CheckCircle2, t: "Volume", d: "Hundreds of pieces shipped monthly." },
                { icon: Clock, t: "Speed", d: "72–96h turnaround, always." },
                { icon: Eye, t: "Quality", d: "Pro-grade design, every time." },
                { icon: Zap, t: "Simplicity", d: "No calls. No fluff." },
              ].map((b, i) => (
                <div key={i} className="snap-card">
                  <div className="w-10 h-10 rounded-md bg-[#3B9EFF]/10 border border-[#3B9EFF]/30 flex items-center justify-center text-[#3B9EFF]">
                    <b.icon size={18} />
                  </div>
                  <h4 className="mt-3 font-display font-bold text-white">{b.t}</h4>
                  <p className="text-[#A0AABF] text-sm mt-1">{b.d}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20">
          <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
            <h2 className="font-display font-black text-white text-4xl md:text-5xl tracking-tighter">
              Built for the busy. <span className="text-[#3B9EFF]">Priced for the smart.</span>
            </h2>
            <div className="mt-8 flex flex-wrap justify-center gap-4">
              <Link to="/offer/pack-99" className="btn-primary" data-testid="about-cta-99">Start with $99.99</Link>
              <Link to="/offer/monthly-175" className="btn-secondary" data-testid="about-cta-175">Go Monthly</Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
